// This file is AUTOGENERATED, do not edit it manually!!!

export const messageBoard = {
    AdditionalRecipients: 'Destinatarios Adicionales',
    Apply: 'Aplicar',
    Approve: 'Aprobar',
    Approver_Approved: 'aprobado',
    Approver_HasNotSeen: 'sin leer',
    Approver_NoAction: 'sin acción',
    Approver_NotApproved: 'visto, aprobación pendiente',
    Approver_Rejected: 'rechazado',
    ApproversGroupTitle: 'Aprobadores',
    Attachment_Delete: 'Archivo  \'{0}\' se ha sido eliminado.',
    BaseNotificationRule: 'Basado en la regla de notificación',
    BeforePageUnloadMessage: 'Sus cambios se perderán. Quiere dejar esta página sin guardar cambios?',
    Cancel: 'Cancelar',
    Close: 'Cerrar',
    ContactAdministrator: 'Por favor, póngase en contacto con su administrador',
    Delete: 'Eliminar',
    DeleteAttachmentContentTemplate: 'Está seguro de que desea eliminar el archivo adjunto \'{0}\' ?',
    DeleteAttachmentTitle: 'Eliminar el archivo adjunto',
    Download: 'Descargar',
    DropHere: 'Suelta archivos aquí',
    Edit: 'Editar',
    edit_actions: 'Presione ctrl + enter para<a apply=\"\">Aplicar</a> o esc para <a>Cancelar</a>',
    email_only_mention_title: 'Este usuario será notificado solo por correo electrónico',
    Error: 'Error',
    FilePlural: '1#{0} Archivo#{0} Archivos',
    FileUploadError: 'Error',
    FileVersion: 'Versión ',
    FileVersionShort: 'ver ',
    FreeSpaceTemplate: 'Ha utilizado {0} MB de {1} MB.',
    HideFiles: 'Ocultar archivos',
    mention_title: 'Menciona a alguien',
    Message_Delete: 'El mensaje ha sido eliminado.',
    message_maxLength_description: 'Un mensaje puede contener hasta 10 000 caracteres.',
    message_maxLength_title: 'El mensaje es demasiado largo',
    MessageDeleteConfirmation: 'Borrar este post?',
    messageEdited: '(editar)',
    MessageEditedBy: 'Editado por ',
    messagePlaceholderText: 'Agrega mensajes, suelta archivos o @menciona a alguien',
    MultipleApproversTemplate: '{0} de {1} {2}',
    NewMessageWatermark: 'Escriba mensaje o suelte archivos...',
    NewPost: '1#{0} nueva publicación #{0} nuevas publicaciones',
    No: 'No',
    NoMatchRecipients: 'No se ha encontrado el miembro',
    NoPermissionToEditMessage: 'Lo sentimos, no tienes permiso para editar este mensaje',
    Notification: 'Notificacion',
    Notify: 'Notificar',
    NotifyLabel: 'Notificar...',
    NotProjectMembers: 'No miembros del proyecto',
    Or: 'o',
    PluralApproved: '1#aprobado#aprobado',
    PluralRejected: '1#{0} rechazado#{0} rechazado',
    Post: 'Enviar',
    PostWatingForApproval: 'La publicación está a la espera de aprobación',
    PreviewImages: 'Vista previa de imágenes',
    ProjectMembers: 'Miembros del proyecto',
    Reject: 'Rechazar',
    RequestApprovalLabel: 'Solicitar aprobación',
    ShowFiles: 'Mostrar archivos',
    ShowNext: 'Mostrar anterior',
    SingleApprovedTemplate: 'Aprobado por {0}',
    SingleApprovedTemplate_You: 'Aprobado por Ud.',
    SingleApproverTemplate: 'Esperando la aprobación de {0}',
    SingleRejectedTemplate: 'Rechazado por {0}',
    SingleRejectedTemplate_You: 'Rechazado por Ud.',
    TabFiles: 'Archivos',
    TabMessages: 'Mensajes',
    Teams: 'Equipos',
    Undo: 'Deshacer',
    UploadedBy: ' por ',
    Yes: 'Sí',
    You: 'Usted',
};
